(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-order-bump"] && !Shopify.designMode) return;
  try {
    class OrderBumpItem extends HTMLElement {
    connectedCallback() {
      this._select = this.querySelector('.order-bump-item__select');
      this._priceEl = this.querySelector('[data-price-el]');
      this._button = this.querySelector('.order-bump-item__button');

      this._button.addEventListener('click', () => this._addToCart());

      if (this._select) {
        this._select.addEventListener('change', () => this._onVariantChange());
      }
    }

    _getCurrentVariantId() {
      return this._select ? this._select.value : this.dataset.variantId;
    }

    _onVariantChange() {
      const option = this._select.selectedOptions[0];
      if (option && this._priceEl) {
        const price = option.dataset.price;
        const comparePrice = option.dataset.comparePrice;
        this._priceEl.innerHTML = comparePrice
          ? `<span class="price">${price}</span><span class="compare-at-price">${comparePrice}</span>`
          : `<span class="price">${price}</span>`;
      }
    }

    async _addToCart() {
      const variantId = this._getCurrentVariantId();
      if (!variantId) return;

      this.dataset.state = 'loading';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
        });

        this.dataset.state = 'default';

        if (res.ok) {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { data: {} }
          }));
        }
      } catch {
        this.dataset.state = 'default';
      }
    }
  }

  if (!customElements.get('order-bump-item')) {
    customElements.define('order-bump-item', OrderBumpItem);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["glb-model-viewer"] && !Shopify.designMode) return;
  try {
    (function () {
    try {
      if (window.__glbMVLoaded || (window.customElements && customElements.get && customElements.get('model-viewer'))) {
        return;
      }
      window.__glbMVLoaded = true;

      var preconnect = document.createElement('link');
      preconnect.rel = 'preconnect';
      preconnect.href = 'https://unpkg.com';
      preconnect.crossOrigin = 'anonymous';
      document.head.appendChild(preconnect);

      var script = document.createElement('script');
      script.type = 'module';
      script.src = 'https://unpkg.com/@google/model-viewer@4.3.1/dist/model-viewer.min.js';
      script.integrity = 'sha384-cprcVQt7wbUl0xngF3PGP6yBB7n4/t+4AoAMG9biiMCGFiWOdzUH10Ie2COTqFNW';
      script.crossOrigin = 'anonymous';
      document.head.appendChild(script);
    } catch (e) {}
  })();

  (function () {
    if (window.__glbFallbackBound) return;
    window.__glbFallbackBound = true;

    document.addEventListener('error', function (event) {
      var target = event.target;
      if (!target || !target.hasAttribute || !target.hasAttribute('data-glb-logo')) return;

      var container = target.parentNode;
      var fallback = container && container.querySelector('[data-glb-fallback]');

      target.style.display = 'none';
      if (fallback) fallback.style.display = '';
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
